interface BlufSummaryProps {
  /** Fully-built BLUF sentence, generated server-side for crawler extraction. */
  text?: string | null;
}

/**
 * BLUF (Bottom Line Up Front) atomic passage container.
 *
 * Designed for Answer Engine Optimization (AEO): the component is wrapped in a
 * semantic `<aside>` with `data-aeo="atomic-passage"` so crawlers and AI engines
 * can treat the paragraph as a high-priority direct answer. The text is rendered
 * during SSR, so it exists in the raw HTML markup.
 */
export function BlufSummary({ text }: BlufSummaryProps) {
  if (!text) return null;
  return (
    <aside
      data-aeo="atomic-passage"
      aria-label="Quick answer summary"
      className="mt-5 rounded-xl border border-border/80 bg-muted/40 p-4 sm:p-5 shadow-sm backdrop-blur-sm"
    >
      <p className="text-base leading-relaxed text-foreground">{text}</p>
    </aside>
  );
}
